import React from "react";
import ReactDOM from "react-dom";
import Button from "./Button";
import PropertyDialog from "../widgets/dialogs/PropertyDialog";
import Utility from "./../utilities/Utility";

export default class AppProperties extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            properties: this.props.properties
        };
    }

    add(property, propId) {
        if(!propId){
            property.id = Utility.uuid4();
        }
        window.apm.setAppProperty(property);
        this.setState({properties: window.apm.serialized.appProperties});
    }

    remove(config) {
        const idx = window.apm.serialized.appProperties.findIndex(p => p.config === config);
        window.apm.serialized.appProperties.splice(idx, 1);
        window.apm.setSerializedChanged();
        this.setState({properties: window.apm.serialized.appProperties});
    }

    componentDidMount() {
        //DEVDES2-1175 - Retroactively adding type property to old appProperties objects
        let currentProperties = this.state.properties;
        let retroProperties = false;
        currentProperties.filter(p => p.variable).forEach(p => {
            if(!p.type){
            p.type ="variableBinding";
            retroProperties = true;
            }
        });
        if(retroProperties) {
            window.apm.setSerializedChanged();
            this.setState({properties: window.apm.serialized.appProperties});
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(JSON.stringify(prevProps.properties) !== JSON.stringify(prevState.properties)){
            this.setState({properties: prevProps.properties});
        }
    }

    openDialog(property) {
        window.apm.popup(
            "Application Property",
            '<div class="app_property_container"></div>',
            (property ? `<button class="w2ui-btn warning delete-button">${window.l.popup.delete}</button>` : "") +
            `<button class="w2ui-btn primary add-button">${window.l.popup.save}</button>` +
            `<button class="w2ui-btn secondary close-button" onclick="w2popup.close();">${window.l.popup.close}</button>`,
            [
                ".app_property_container",
                () => {
                    ReactDOM.render(
                        <PropertyDialog context={this} property={property} />,
                        $(".app_property_container").get(0)
                        );
                        $(".w2ui-popup").find(".add-button").on("click", function () {
                            document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                        });
                        $(".w2ui-popup").find(".delete-button").on("click", function () {
                            document.dispatchEvent(new CustomEvent("ev-dialog-delete"));
                        });
                }
            ]
        );
    }

    render() {
        return (
            <div className="container-fluid" >
                <h5 style={{color: "red", textAlign: 'center'}}>WARNING: This feature requires PE 5.8.0+</h5>
                <div className="row">
                    <div className="col-md-12">
                        
                        <Button
                            label={"+"}
                            type={"small"}
                            desc={"New Property"}
                            callback={() => this.openDialog()}
                            context={this}
                        />
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Config Name</th>
                                    <th>Config Default Value</th>
                                    <th>Variable Binding</th>
                                    <th style={{width: "30px"}}/>
                                </tr>
                            </thead>
                            <tbody className="property-list">
                            {this.state.properties.filter(p => p.type === "variableBinding").map((p, i) => {
                                return <tr key={i} onClick={() => this.openDialog(p)}>
                                    <td>{p.config}</td>
                                    <td>{p.default}</td>
                                    <td><i className="fe icon-hash"/> {p.variable}</td>
                                    <td className="icon"><i className="fe icon-edit-3"/></td>
                                </tr>;
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}